export const KrediKartiKomisyon = 1;